import { useLayoutEffect, useRef, useState } from 'react';

// Custom hook para detectar si un elemento tiene overflow horizontal (y por lo tanto, ellipsis)
const useDetectOverflow = () => {
  const labelRef = useRef(null);
  const [hasOverFlow, setHasOverFlow] = useState(false);

  const checkForOverflow = () => {
    if (labelRef.current) {
      const element = labelRef.current;
      // Solo medimos si el elemento tiene ancho
      if (element.offsetWidth > 0) {
        const hasOverflow = element.offsetWidth < element.scrollWidth;
        setHasOverFlow(hasOverflow);
      }
    }
  };

  useLayoutEffect(() => {
    if (!labelRef.current) return;
    const element = labelRef.current;
    // Usamos ResizeObserver para detectar cambios de tamaño en el elemento
    if (!window.ResizeObserver) return;
    const observer = new window.ResizeObserver(() => {
      checkForOverflow();
    });
    observer.observe(element);
    // Medimos al montar por primera vez
    checkForOverflow();

    // eslint-disable-next-line consistent-return
    return () => observer.disconnect();
  }, []);

  return { labelRef, hasOverFlow };
};

export default useDetectOverflow;
